/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Subdomain } from './Subdomain';
import {
    SubdomainFromJSON,
    SubdomainFromJSONTyped,
    SubdomainToJSON,
    SubdomainToJSONTyped,
} from './Subdomain';

/**
 * 
 * @export
 * @interface PaginatedSubdomainList
 */
export interface PaginatedSubdomainList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedSubdomainList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedSubdomainList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedSubdomainList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<Subdomain>}
     * @memberof PaginatedSubdomainList
     */
    results: Array<Subdomain>;
}

/**
 * Check if a given object implements the PaginatedSubdomainList interface.
 */
export function instanceOfPaginatedSubdomainList(value: object): value is PaginatedSubdomainList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function PaginatedSubdomainListFromJSON(json: any): PaginatedSubdomainList {
    return PaginatedSubdomainListFromJSONTyped(json, false);
}

export function PaginatedSubdomainListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedSubdomainList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(SubdomainFromJSON)),
    };
}

  export function PaginatedSubdomainListToJSON(json: any): PaginatedSubdomainList {
      return PaginatedSubdomainListToJSONTyped(json, false);
  }

  export function PaginatedSubdomainListToJSONTyped(value?: PaginatedSubdomainList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(SubdomainToJSON)),
    };
}

